import React, {Component} from 'react';
import {Switch, Route, withRouter, Redirect} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

import { Request } from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';

import Header from './../../APP/COMPONENTS/Header';
import LeftNav from './../../APP/COMPONENTS/LeftNav';
import Loader from './../../APP/COMPONENTS/Loader';

function mapStateToProps(state, myProps) {
    return {
        USER: state.USER
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}


class Complaints extends Component {
	constructor(props)
    {
        super(props);
        this.state = {
            USER: this.props.USER,
            LOADED: false,
            PRODUCTS: false,
            COMPLAINTS: false,
            DATE: '',
            FILTER: {
                TITLE: null
            }
        }
    }

    componentDidMount = () =>
    {
        this.fetchProducts();
    }


    componentDidUpdate(prevProps, prevState, snapshot)
    {

        if (this.props.USER !== prevProps.USER) {
            this.setState({USER: this.props.USER});
        }
    }

    fetchProducts = async () =>
    {
        try {
            let SEND_DATA = {
                date:       this.state.DATE
            };

            let data = await Request(SEND_DATA,'products/complaints');
            if (data !== false) {
                this.setState({PRODUCTS: data.products, GROUPS: data.categories, LOADED: true});
            } else {
                this.setState({LOADED: true});
            }
        } catch (error) {
        }
    }

    renderProducts = () =>
    {
        if (this.state.LOADED) {
            if (this.state.PRODUCTS && this.state.PRODUCTS.length) {
                let PRODUCTS = this.filterProducts();
                let TBODY = this.renderProductsRows(PRODUCTS);
                let HEADER = this.renderProductsTableHeader();

                return (
                    <div className="table_holder">
                        <table id="products_table" className="products_table" cellPadding="0" cellSpacing="0">
                            {HEADER}
                            {TBODY}
                        </table>
                        <table id="products_table_saveable" className="products_table_saveable" cellPadding="0" cellSpacing="0">
                            {this.renderProductsTableHeader(true)}
                            {this.renderProductsRows(PRODUCTS, true)}
                        </table>                        
                    </div>
                );
            } else {
                return <div className="table_holder"><h3>Мы не нашли жалоб на ваши товары</h3></div>;
            }
        } else {
            return <div className="table_holder"><Loader /><div className="loader_content">Собираем статистику по товарам ...</div></div>
        }
    }

    renderImage = (PRODUCT) =>
    {
        let SRC = PRODUCT.thumb;
        if ((typeof SRC !== "undefined") && (SRC !== "")) {
            return (
                <img
                    className="product_image"
                    src={SRC}
                />
            );
        }

        return false;
    }

    getProductGroups = (PRODUCT) => {
        let GROUPS = [];
        for (let i = 0; i < PRODUCT.categories.length; i++) {
            let GROUP = false;

            for (let j = 0; j < this.state.GROUPS.length; j++) {
                if (this.state.GROUPS[j].id.toString() == PRODUCT.categories[i].toString()) {
                    GROUP = this.state.GROUPS[j].name;
                }
            }

            if (GROUP) {
                GROUPS.push(<span key={ i } className="group_title">{ GROUP }</span>);
            }
        }

        return GROUPS;
    }

    renderProductStatuses = (PRODUCT) =>
    {
        let STATUSES = [];
        if (parseInt(PRODUCT.archive) == 1) {
            STATUSES.push(
                <span key="archive" className="archive_label">Архив</span>
            );
        }
        if (parseInt(PRODUCT.active) == 1) {
            STATUSES.push(
                <span key="disabled" className="disabled_label">Отключен</span>
            );
        }

        if (STATUSES.length) {
            return (
                <div className="product_title_labels">
                    {STATUSES}
                </div>
            );
        }

        return null;
    }

    addAmountClassToCell = (AMOUNT) =>
    {
        if (parseInt(AMOUNT) == 0) {
            return ' out_of_stock_cell';
        }

        return null;
    }

    countComplaints = (text, PRODUCT) =>
    {
        let count = 0;

        for (let i = 0; i < PRODUCT.complaints.length; i++) {
            if (PRODUCT.complaints[i][text]) {
                count++;
            }
        }

        return count;
    }

    renderProductsRows = (PRODUCTS, SAVEABLE) =>
    {
        let ROWS = [];
        for (let i = 0; i < PRODUCTS.length; i++) {
            let PRODUCT = PRODUCTS[i];

            ROWS.push(
                <tr key={i}>
                    {(typeof SAVEABLE !== "undefined") ? null : (<td className="cell-center">{this.renderImage(PRODUCT)}</td>)}
                    <td><span className="product_title">{PRODUCT.name}{this.renderProductStatuses(PRODUCT)}</span></td>
                    <td>{this.getProductGroups(PRODUCT)}</td>
                    <td>{this.countComplaints('Качество', PRODUCT)}</td>
                    <td>{this.countComplaints('Пересорт', PRODUCT)}</td>
                    <td>{this.countComplaints('ТоварПросрочен', PRODUCT)}</td>
                    <td>{this.countComplaints('Другое', PRODUCT)}</td>
                </tr>
            );
        }

        return (
            <tbody>
                {ROWS}
            </tbody>
        );
    }

    renderProductsTableHeader = (SAVEABLE) =>
    {
        return (
            <thead>
                <tr>
                    {(typeof SAVEABLE !== "undefined") ? null : (<th>фото</th>)}
                    <th>наименование</th>
                    <th>категории</th>
                    <th>качество</th>
                    <th>пересорт</th>
                    <th>просрочка</th>
                    <th>другое</th>
                </tr>
            </thead>
        );
    }

    renderFiter = () =>
    {
        return (
            <div className="filter_head">
                <h1>Жалобы на товары</h1>
                {this.renderDateInput()}
                {this.renderSearchInput()}
            </div>
        );
    }

    appendFilter = (data, type) => {
        let FILTER = this.state.FILTER;
        if (type == 'GROUP') {
            let value = data.target.value;
            if (value == 0) {
                value = null;
            }
            FILTER[type] = value;
        } else if (type == 'DISABLED') {
            FILTER[type] = !this.state.FILTER.DISABLED;
        } else if (type == 'ARCHIVE') {
            FILTER[type] = !this.state.FILTER.ARCHIVE;
        } else if (type == 'OUTOFSTOCK') {
            FILTER[type] = !this.state.FILTER.OUTOFSTOCK;
        } else {
            FILTER[type] = data.target.value;
        }

        this.setState({FILTER: FILTER});
    }

    filterProducts = () => {
        let FILTER_RESULTS = [];
        let STRING = null;
        let COMPARE = null;

        for (let i = 0; i < this.state.PRODUCTS.length; i++) {
            let PRODUCT = this.state.PRODUCTS[i];
            let FOUND = true;

            if (FOUND) {
                if (this.state.FILTER.TITLE !== null) {
                    STRING = PRODUCT.title.toUpperCase();
                    COMPARE = this.state.FILTER.TITLE.toUpperCase();

                    if (STRING.indexOf(COMPARE) !== -1) {
                        FOUND = true;
                    } else {
                        FOUND = false;
                    }
                }
            }

            if (FOUND) {
                FILTER_RESULTS.push(PRODUCT);
            }
        }
        return FILTER_RESULTS;

    }

    renderDateInput = () =>
    {
        return (
            <div className="filter_inputs_holder">
                <div className="filter_element">
                    <input
                        type="date"
                        onChange={(text) => this.setState({PRODUCTS: false, DATE: text.target.value, LOADED: false, COMPLAINTS: false}, () => this.fetchProducts())} 
                    />
                </div>
            </div>
        );
    }

    renderSearchInput = () =>
    {
        if (this.state.LOADED) {
            return (
                <div className="filter_inputs_holder">
                    <div className="filter_element">
                        <input
                            type="text"
                            placehodler="Поиск"
                            value={this.state.FILTER.TITLE}
                            onChange={(text) => this.appendFilter(text, 'TITLE')} 
                        />
                        <img className="search_icon" src="/system_images/search_icon.png" />
                    </div>
                </div>
            );
        }
    }

    render() {
        if (!this.state.USER) {
            return <Redirect to="/"/>
        }

        return (
            <div className="main_content">
                <Helmet>
                    <title>Жалобы на товары</title>
                </Helmet>
                {this.renderFiter()}
                {this.renderProducts()}
            </div>
        );
	}
}

export default withRouter(connect(
	mapStateToProps, mapDispatchToProps
)(Complaints))
